import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import WhyAustralia from "@/pages/WhyAustralia";
import Universities from "@/pages/Universities";
import UniversityProfile from "@/pages/UniversityProfile";
import Scholarships from "@/pages/Scholarships";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import StudentProfile from "@/pages/StudentProfile";
import AuthCallback from "@/components/AuthCallback";
import { StudentAuthProvider } from "@/lib/auth";

function useLenis() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return lenisRef;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id — synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/why-australia" element={<WhyAustralia />} />
      <Route path="/universities" element={<Universities />} />
      <Route path="/universities/:slug" element={<UniversityProfile />} />
      <Route path="/scholarships" element={<Scholarships />} />
      <Route path="/guides" element={<Guides />} />
      <Route path="/guides/:slug" element={<GuideArticle />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/profile" element={<StudentProfile />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <StudentAuthProvider>
          <ScrollToTop />
          <AppRouter />
        </StudentAuthProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
